module.exports = {
  name: 'English',
  key: 'en',
  'Open in Debug Map': 'Open in Debug Map',
  'Open in Mapillary': 'Open in Mapillary',
  'GPX': 'Export GPX file',
  'Open in editor': 'Open in editor',
  'Open in JOSM': 'Open in JOSM',
  'Select language': 'Select language',
  'Share Route': 'Share Route',
  'Link': 'Link',
  'Shortlink': 'Shortlink',
  'Start - press enter to drop marker': 'Start - press enter to drop marker',
  'End - press enter to drop marker': 'End - press enter to drop marker',
  'Via point - press enter to drop marker': 'Via point - press enter to drop marker',
  'Bike': 'Bike',
  'Car': 'Car',
  'Foot': 'Foot',
  'Build': 'Build: '
};
